import {
  TrialUserSubscriptionDataFragment,
  useGetTrialSubscriptionQuery
} from "generated/graphql";
import { useMemo } from "react";

export type TrialSubscription = {
  id: string;
  meetingUrl: string;
  meetingRoomId: string;
};

export const toTrialSubscription = (
  data: TrialUserSubscriptionDataFragment
): TrialSubscription => {
  return {
    id: data.id,
    meetingUrl: data.meetingUrl,
    meetingRoomId: data.meetingRoomId
  };
};

export const useGetTrialSubscription = () => {
  const queryResults = useGetTrialSubscriptionQuery();

  const data = useMemo(() => {
    let result;
    const sourceData = queryResults.data?.getTrialSubscription;
    if (sourceData) {
      result = toTrialSubscription(sourceData);
    }
    return result;
  }, [queryResults.data]);

  return { ...queryResults, data };
};
